import Soon from "@/views/integration/components/Soon";
import Line from "@/views/broadcastByChannel/components/LineList";
import Sms from "@/views/broadcastByChannel/components/SmsList";
export default {
  path: "/:appId/omni/broadcast",
  name: "omni.broadcast",
  component: () => import("@/views/broadcast/pages/BroadcastMainPage.vue"),
  redirect: { name: "omni.broadcast.message" },
  props: true,
  meta: {
    title: "Broadcast Message",
  },
  children: [
    {
      path: "broadcast-by-channel",
      name: "omni.broadcast.broadcast-by-channel",
      meta: {
        title: "Broadcast By Channel",
      },
      component: () =>
        import("@/views/broadcastByChannel/pages/broadcastByChannelPage.vue"),
      redirect: { name: "omni.broadcast-by-channel.line" },
      props: true,
      children: [
        {
          path: "line",
          name: "omni.broadcast-by-channel.line",
          component: Line,
        },
        {
          path: "facebook",
          name: "omni.broadcast-by-channel.facebook",
          component: Soon,
        },
        {
          path: "telegram",
          name: "omni.broadcast-by-channel.telegram",
          component: Soon,
        },
        {
          path: "whatsapp",
          name: "omni.broadcast-by-channel.whatsapp",
          component: Soon,
        },
        {
          path: "webchat",
          name: "omni.broadcast-by-channel.webchat",
          component: Soon,
        },
        {
          path: "mobile",
          name: "omni.broadcast-by-channel.mobile",
          component: () =>
            import("@/views/broadcast/pages/BroadcastMessagePage.vue"),
        },
        {
          path: "mobile-omni",
          name: "omni.broadcast-by-channel.mobile-omni",
          component: Soon,
        },
        {
          path: "twitter",
          name: "omni.broadcast-by-channel.twitter",
          component: Soon,
        },
        {
          path: "qiscus",
          name: "omni.broadcast-by-channel.qiscus",
          component: Soon,
        },
        {
          path: "instagram",
          name: "omni.broadcast-by-channel.instagram",
          component: Soon,
        },
        {
          path: "ticket",
          name: "omni.broadcast-by-channel.ticket",
          component: Soon,
        },
        {
          path: "email",
          name: "omni.broadcast-by-channel.email",
          component: Soon,
        },
        {
          path: "tokopedia",
          name: "omni.broadcast-by-channel.tokopedia",
          component: Soon,
        },
        {
          path: "External API",
          name: "omni.broadcast-by-channel.external",
          component: Soon,
        },
        {
          path: "Sms",
          name: "omni.broadcast-by-channel.sms",
          component: Sms,
        },
        {
          path: "soon",
          name: "omni.broadcast-by-channel.soon",
          component: Soon,
        },
      ],
    },
    {
      path: "message",
      name: "omni.broadcast.message",
      meta: {
        title: "Broadcast Message",
      },
      component: () =>
        import("@/views/broadcast/pages/BroadcastMessagePage.vue"),
    },
    {
      path: "whatsapp-non-hsm",
      name: "omni.broadcast.whatsapp-non-hsm",
      meta: {
        title: "Broadcast Message",
      },
      component: () =>
        import("@/views/broadcast/pages/WhatsappBroadcastPage.vue"),
    },
  ],
};
